import { useMemo } from 'react';
import { useAppSelector } from './useAppSelector';
import { getFinalUTCDateRange } from './useFormatDateTime';

/**
 * Returns the default stats payload object used for API requests or table data.
 *
 * This function generates a payload with today's date set to the start of the day (00:00:00)
 * for both `StartDate` and `EndDate`. All other fields are initialized with default values:
 *
 */

export const useStatsPayload = () => {
  const range = useAppSelector((state) => state.dateFilter);
  const selectedZone = useAppSelector((state) => state.configSlice.timeZone);
  const { startDate, endDate } = getFinalUTCDateRange(range, selectedZone);

  const payload = useMemo(
    () => ({
      Date: {
        StartDate: startDate,
        EndDate: endDate,
      },
      groupBy: 4,
      clients: null,
      companies: null,
      regions: null,
      groups: null,
      locations: null,
      statisticBy: 3,
      games: null,
      CCY: null,
      paymentSources: null,
      hasTestData: true,
      OrderBy: null,
    }),
    // We intentionally keep the dependency array empty because this payload must not update when startDate or endDate change.
    // eslint-disable-next-line 
    [],
  );

  return payload;
};
